// Knopf „Excel“ in den Listen eines Projekts (Aufgaben, Entscheidungen, Meilensteine, offene Punkte, Tests, Checklisten, Abnahmen):
// lädt die Excel-Datei des Bereichs vom Server. Exportieren dürfen alle Mitglieder, auch im archivierten Projekt.
import { useState } from 'react';
import { api } from '../api';
import { EXPORT_BEREICH, type ExportBereich } from '../listenexport';
import { download } from '../logik/io.js';
import { Icon } from './Icon';
import { toast } from './toast';

export function ExportKnopf({ projektId, bereich }: { projektId: string; bereich: ExportBereich }) {
  const [laeuft, setLaeuft] = useState(false);
  const laden = async () => {
    setLaeuft(true);
    try {
      const d = await api.listeExport(projektId, bereich);
      download(d.blob, d.name);
    } catch (e) { toast('Export nicht möglich: ' + (e as Error).message, true); }
    finally { setLaeuft(false); }
  };
  return (
    <button className="btn" disabled={laeuft} onClick={() => void laden()} data-testid={'export-' + bereich}
      title={`Alle ${EXPORT_BEREICH[bereich]} des Projekts als Excel-Datei – gespeicherter Stand, unabhängig vom Filter`}>
      <Icon name="download" /> Excel
    </button>
  );
}
